import { Link } from 'react-router-dom';
import { useDesign } from '@/contexts/DesignContext';
import { defaultBrandingTokens } from '@/design-system/tokens/branding';
import { useTranslation } from 'react-i18next';
import { HStack, VStack } from '@/components/core';

export function Footer() {
  const { config } = useDesign();
  const { t } = useTranslation('common');
  return (
    <footer className="hidden md:block w-full border-t border-white/10 bg-black/20 backdrop-blur supports-[backdrop-filter]:bg-black/10">
      <VStack className="container mx-auto px-token-md py-token-lg md:flex-row items-center justify-between" gap="md">
        <p className="text-sm text-white/60">
          © {new Date().getFullYear()} {config?.branding?.site_title || defaultBrandingTokens.siteName}
          {config?.show_ai_disclaimer && (
            <span className="ml-4 opacity-60 text-xs">* KI-generierter Inhalt</span>
          )}
        </p>
        <HStack as="nav" gap="lg" align="center" className="text-sm">
          <Link to="/impressum" className="text-white/80 hover:text-white transition-colors">{t('legal.impressum')}</Link>
          <Link to="/datenschutz" className="text-white/80 hover:text-white transition-colors">{t('legal.privacy')}</Link>
          <Link to="/agb" className="text-white/80 hover:text-white transition-colors">{t('legal.terms')}</Link>
        </HStack>
      </VStack>
    </footer>
  );
}


